// MUTATIONS
export const MUTATION_DECISION_ID                   = 'setDecisionIdMutation'
export const MUTATION_DECISION_OWNER                = 'setDecisionOwnerMutation'
export const MUTATION_CURRENT_TAXON                 = 'setCurrentTaxonMutation'
export const MUTATION_CRITERIA                      = 'setCriteriaMutation'
export const MUTATION_SORT_ASCENDING                = 'setSortAscendingMutation'

export const MUTATION_SORT_METHOD                   = 'setSortMethodMutation'
export const MUTATION_SORT_CRITERIA                 = 'setSortCriteriaMutation'
export const MUTATION_CHOSEN_OPTION                 = 'setChosenOptionMutation'
export const MUTATION_CURRENT_LIST                  = 'setCurrentListMutation'
export const MUTATION_RESEARCH_DOCS                 = 'setResearchDocsMutation'
export const MUTATION_OPTIONS                       = 'setOptionsMutation'
export const MUTATION_OPTION_NAME                   = 'setOptionNameMutation'
export const MUTATION_OPTION_NEWLY_ADDED            = 'setOptionNewlyAddedMutation'
export const MUTATION_OPTION_IS_SHORTLISTED         = 'setOptionIsShortlistedMutation'
export const MUTATION_OPTION_SCRAPE_STATE           = 'setOptionScrapeStateMutation'
export const MUTATION_OPTION_SCRAPE_RESULT          = 'setOptionScrapeResultMutation'
export const MUTATION_OPTION_RE_SCRAPE_RESULT          = 'setOptionReScrapeResultMutation'
export const MUTATION_OPTION_HASH                   = 'setOptionSha256Mutation'
export const MUTATION_OPTION_CRITERIA_VALUES        = 'setOptionCriteriaValuesMutation'
export const MUTATION_OPTION_SCRAPE_DATA            = 'setOptionScrapeDataMutation'
export const MUTATION_OPTION_APPROVED_DATA          = 'setOptionApprovedDataMutation'
export const MUTATION_FETCHING_STATUS               = 'setFetchingStatusMutation'
export const MUTATION_UPDATE_OPTION_CHECKED_TIME    = 'setCheckURLTime'
export const MUTATION_UPDATE_CONTENT_STATE          = 'setContentState'
export const MUTATION_ADD_OPTION                    = 'addOptionMutation'
export const MUTATION_REMOVE_OPTION                 = 'removeOptionMutation'
export const MUTATION_ADD_RESEARCH_DOC              = 'addResearchDocMutation'
export const MUTATION_REMOVE_RESEARCH_DOC           = 'removeResearchDocMutation'

// ACTIONS
